/*
 * Public API Surface of ngx-pica
 */

export {NgxPicaModule} from './lib/ngx-pica.module';
export {NgxPicaService} from './lib/ngx-pica.service';
export {NgxPicaImageService} from './lib/ngx-pica-image.service';
export {NgxPicaErrorInterface} from './lib/ngx-pica-error.interface';
export {NgxPicaResizeOptionsInterface} from './lib/ngx-pica-resize-options.interface';
